export const PreviewThumbnails = ({ previews }: { previews: string[] }) => {
    return (
        <div className="previewThumbnails">
            {previews.length > 0 ? (
                previews
                    .filter((previewSrc, i) => {
                        if (i === previews.length - 1 && previewSrc === undefined) {
                            // ffmpeg sometimes fails on the last frame if it's very close to the end of the video
                            // avoid jumpiness / loading spinner for this frame
                            return false;
                        }
                        return true;
                    })
                    .map((previewSrc, index) =>
                        previewSrc ? (
                            <img
                                key={`preview-${index}`}
                                src={previewSrc}
                                alt={`Frame ${index + 1}`}
                                className="thumbnail"
                            />
                        ) : (
                            <div
                                key={`preview-${index}`}
                                className="flex h-full flex-1 items-center justify-center bg-gray-100 text-xs text-tertiary"
                            >
                                <i className="far fa-spinner fa-spin text-xs text-black"></i>
                            </div>
                        )
                    )
            ) : (
                <div className="flex h-full w-full items-center justify-center bg-gray-100 text-xs text-tertiary">
                    Loading previews...
                </div>
            )}
        </div>
    );
};
